import React, { useEffect, useState } from "react";
import "./style.scss";
import { useLocation } from "react-router-dom";
import { getDetailOrderByID } from "services/user/orderService";
import { PacmanLoader } from "react-spinners";
import { FormatDateHours, addDaysToDate } from "utils/formatDate";
import { Formatter } from "utils/formatter";
// import 'pe-icon-7-stroke/css/pe-icon-7-stroke.min.css';
import {
  FaBoxOpen,
  FaShippingFast,
  FaHandshake,
  FaCheckCircle,
} from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";

const OrderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderID = location.state?.orderID;
  const [orderDetails, setOrderDetails] = useState(null);
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useState("");
  const [dateOrder, setDateOrder] = useState("");
  const [orderStatusHistory, setOrderStatusHistory] = useState("");
  useEffect(() => {
    const fetchOrderDetails = async () => {
      setIsLoading(true);
      if (orderID && token) {
        try {
          const data = await getDetailOrderByID(token, orderID);
          setOrderDetails(data.data);
          console.log("status", data.data.orderStatus);
          setOrderStatus(data.data.orderStatus);
          setDateOrder(data.data.dateOrder);
          setOrderStatusHistory(data.data.orderStatusHistory);
        } catch (err) {
          console.error("Error fetching order details:", err);
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchOrderDetails();
  }, [orderID, token]);

  if (!orderDetails)
    return (
      <section className="productDetails section d-flex justify-content-center">
        <PacmanLoader color="#5E2E86" />
      </section>
    );

  const getStepClass = (stepStatus) => {
    // Kiểm tra nếu trạng thái của bước là "completed"
    if (stepStatus === "completed") {
      return "completed"; 
    }

    // Định nghĩa trạng thái của đơn hàng
    const orderStatuses = [
      "Chờ xác nhận",
      "Đang đóng gói",
      "Đang vận chuyển",
      "Đã giao",
    ];
    const currentStepIndex = orderStatuses.indexOf(orderStatus);
    const stepIndex = orderStatuses.indexOf(stepStatus);
    if (stepIndex <= currentStepIndex) {
      return "completed";
    }
    return orderStatus === stepStatus ? "active" : "";
  };

  const datePlus3 = addDaysToDate(dateOrder, 3);
  const datePlus5 = addDaysToDate(dateOrder, 5);

  const getStatusTime = (status) => {
    const statusObj = orderStatusHistory.find((item) => item.status === status);
    return statusObj ? FormatDateHours(statusObj.dateUpdated) : "";
  };

  return (
    <div className="order-details-container">
      <div className="title-detail-order">Chi tiết đơn hàng của bạn</div>
      <div className="container padding-bottom-3x mb-1">
      {orderDetails.orderStatus !== "Đã hủy" && (
  <div className="card mb-3">
    <div className="p-2 rounded-top"></div>
    <div className="d-flex flex-wrap flex-sm-nowrap justify-content-between py-3 px-2 bg-secondary">
      <div className="w-100 text-center py-1 px-2">
        {orderDetails.orderStatus === "Đã giao" ? (
          <span className="status-icon">
            Cảm ơn bạn đã mua hàng! <FaCheckCircle />
          </span>
        ) : (
          orderDetails.orderStatus !== "Đã hủy" && (
            <span className="text-large">
              Dự kiến nhận hàng: {datePlus3} - {datePlus5}
            </span>
          )
        )}
      </div>
    </div>

    {/* Chỉ hiển thị các bước nếu trạng thái không phải là "Đã hủy" */}
    <div className="card-body">
      <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
        <div className={`step ${getStepClass("Chờ xác nhận")}`}>
          <div className="step-icon-wrap">
            <div className="step-icon">
              <i className="pe-7s-cart">
                <MdOutlinePendingActions />
              </i>
            </div>
          </div>
          <h4 className="step-title">Chờ xác nhận</h4>
          <h4 className="step-title">{getStatusTime("Chờ xác nhận")}</h4>
        </div>
        <div className={`step ${getStepClass("Đang đóng gói")}`}>
          <div className="step-icon-wrap">
            <div className="step-icon">
              <i className="pe-7s-config">
                <FaBoxOpen />
              </i>
            </div>
          </div>
          <h4 className="step-title">Đang đóng gói</h4>
          <h4 className="step-title">{getStatusTime("Đang đóng gói")}</h4>
        </div>

        <div className={`step ${getStepClass("Đang vận chuyển")}`}>
          <div className="step-icon-wrap">
            <div className="step-icon">
              <i className="pe-7s-car">
                <FaShippingFast />
              </i>
            </div>
          </div>
          <h4 className="step-title">Đang vận chuyển</h4>
          <h4 className="step-title">{getStatusTime("Đang vận chuyển")}</h4>
        </div>
        <div className={`step ${getStepClass("Đã giao")}`}>
          <div className="step-icon-wrap">
            <div className="step-icon">
              <i>
                <FaHandshake />
              </i>
            </div>
          </div>
          <h4 className="step-title">Đã giao</h4>
          <h4 className="step-title">{getStatusTime("Đã giao")}</h4>
        </div>
      </div>
    </div>
  </div>
)}

</div>


      <div className="order-content">
        <div className="order-info">
          <p>
            <strong>Trạng thái:</strong> {orderDetails.orderStatus}
          </p>
          <p>
            <strong>Phương thức thanh toán:</strong>{" "}
            {orderDetails.paymentMethod}
          </p>
          <p>
            <strong>Trạng thái thanh toán:</strong> {orderDetails.paymentStatus}
          </p>
          <p>
            <strong>Người nhận:</strong> {orderDetails.shippingInfo.receiver}
          </p>
          <p>
            <strong>Email:</strong> {orderDetails.email}
          </p>
          <p>
            <strong>Số điện thoại:</strong>{" "}
            {orderDetails.shippingInfo.phoneNumber}
          </p>
          <p>
            <strong>Địa chỉ:</strong> {orderDetails.shippingInfo.address}
          </p>

          <p>
            <strong>Thời gian đặt hàng:</strong>{" "}
            {FormatDateHours(orderDetails.dateOrder)}
          </p>

          <div className="order-fees">
            <div className="order-fee-item">
              <p>
                <strong>Tổng tiền hàng:</strong>
              </p>
              <p>
                {Formatter(orderDetails.totalPrice - orderDetails.shippingFee)}
              </p>
            </div>
            <div className="order-fee-item">
              <p>
                <strong>Phí vận chuyển:</strong>
              </p>
              <p>{Formatter(orderDetails.shippingFee)}</p>
            </div>
            <div className="order-fee-item">
              <p>
                <strong>Thành tiền:</strong>
              </p>
              <p>{Formatter(orderDetails.totalPrice)}</p>
            </div>
          </div>
        </div>

        <div className="items-list">
          {orderDetails.items.map((item) => (
            <div key={item.bookID} className="item">
              <img
                src={item.imageLink}
                alt={item.title}
                className="item-image"
              />
              <div className="item-details">
                <p className="item-title">{item.title}</p>
                <p>
                  <strong>Số lượng:</strong> {item.quantity}
                </p>
                <p>
                  <strong>Giá giảm:</strong>{" "}
                  {item.discountedPrice.toLocaleString()} VND
                </p>
              </div>
            </div>
          ))}
        </div>

       

      </div>

      {orderDetails.refundDetail && (
    <div className="refund-details">
      <h4>Thông tin hoàn tiền</h4>
      <p style={{ margin: 0 }}>
  Quá trình hoàn tiền sẽ mất từ 7-10 ngày, chúng tôi sẽ hoàn tiền về tài khoản ngân hàng của bạn!
</p>
      <span> Ngân hàng {orderDetails.refundDetail.bankShortName}  {" "}
                    STK {orderDetails.refundDetail.accountNumber} -{" "}
                    {orderDetails.refundDetail.accountName}
                  </span>
      <p style={{ margin: 0 }} ><strong>Trạng thái:</strong> {orderDetails.refundDetail.status}</p>
      <p style={{ margin: 0 }}><strong>Ngày hoàn tiền:</strong> {orderDetails.refundDetail.refundedAt || "Chưa hoàn tiền"}</p>
      <br />     
      <p className="note">Lưu ý: Nếu cần chỉnh sửa thông tin tài khoản ngân hàng, bạn truy cập vào trang thông tin cá nhân!</p>
                 

      
    </div>
  )}

      {orderDetails.orderStatus === "Chờ xác nhận" && (
                    <button
                      className="cancel-order-btn"
                      onClick={() => navigate("/cancel-order", {
                        state: { orderID: orderDetails.orderID, orderPaymentStatus: orderDetails.paymentStatus },
                      })}
                    >
                      Hủy đơn
                    </button>
                  )}
    </div>
  );
};

export default OrderDetails;
